import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const TopBar = () => {
    const { isAuthenticated, user, logout, isAdmin } = useAuth();
    const [showUserMenu, setShowUserMenu] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowUserMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleConsultationClick = () => {
        if (isAuthenticated) {
            navigate('/consultation');
        } else {
            navigate('/user-login?redirect=consultation');
        }
    };

    const handleLogout = () => {
        logout();
        setShowUserMenu(false);
        navigate('/');
    };

    return (
        <div className="top topbar-modern">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="topbar-inner">
                            <ul className="flat-infomation topbar-contact">
                                <li className="phone"><Link to="tel:+255749663117" title="phone"><i className="fa fa-phone" aria-hidden="true"></i> +255 749 663 117</Link></li>
                                <li className="email"><Link to="mailto:info@statselite.co.tz" title="email"><i className="fa fa-envelope" aria-hidden="true"></i> info@statselite.co.tz</Link></li>
                            </ul>
                            <div className="flat-questions topbar-actions">
                            <Link to="/contact-v1" title="" className="questions">Have a data challenge</Link>
                            <button onClick={handleConsultationClick} title="" className="appointment" style={{
                                background: 'none',
                                border: 'none',
                                color: '#fff',
                                cursor: 'pointer',
                                fontSize: '12px',
                                fontWeight: '600',
                                padding: '0',
                                textDecoration: 'none',
                                fontFamily: 'inherit'
                            }}>REQUEST A CONSULTATION</button>

                            {isAuthenticated ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} ref={menuRef}>
                                    <div style={{ position: 'relative' }}>
                                        <button
                                            onClick={() => setShowUserMenu(!showUserMenu)}
                                            style={{
                                                background: 'rgba(255, 255, 255, 0.1)',
                                                color: '#fff',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                borderRadius: '4px',
                                                padding: '6px 14px',
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}
                                            onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                                            onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
                                        >
                                            <i className="fa fa-user-circle" style={{ fontSize: '14px' }}></i>
                                            {user?.name?.split(' ')[0] || 'User'}
                                            <i className={`fa fa-chevron-down ${showUserMenu ? 'fa-rotate-180' : ''}`} style={{ fontSize: '10px', transition: 'transform 0.2s' }}></i>
                                        </button>
                                    </div>

                                    <button
                                        onClick={handleLogout}
                                        title="Sign Out"
                                        style={{
                                            padding: '6px 14px',
                                            background: '#e53e3e',
                                            color: '#fff',
                                            borderRadius: '4px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            border: 'none',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                        onMouseEnter={(e) => e.target.style.background = '#c53030'}
                                        onMouseLeave={(e) => e.target.style.background = '#e53e3e'}
                                    >
                                        <i className="fa fa-sign-out" style={{ fontSize: '12px' }}></i> SIGN OUT
                                    </button>

                                    {showUserMenu && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: 0,
                                            marginTop: '8px',
                                            background: '#fff',
                                            borderRadius: '4px',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                            minWidth: '180px',
                                            zIndex: 1000,
                                            overflow: 'hidden'
                                        }}>
                                            <div style={{
                                                padding: '12px 16px',
                                                borderBottom: '1px solid #e0e0e0',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                color: '#333'
                                            }}>
                                                <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px' }}>Signed in as</div>
                                                <div style={{ fontSize: '13px', fontWeight: '600' }}>{user?.email}</div>
                                            </div>
                                            <button
                                                onClick={() => {
                                                    setShowUserMenu(false);
                                                    navigate('/consultation');
                                                }}
                                                style={{
                                                    width: '100%',
                                                    padding: '10px 16px',
                                                    background: 'none',
                                                    border: 'none',
                                                    textAlign: 'left',
                                                    cursor: 'pointer',
                                                    fontSize: '13px',
                                                    color: '#333',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }}
                                                onMouseEnter={(e) => e.target.style.background = '#f5f5f5'}
                                                onMouseLeave={(e) => e.target.style.background = 'none'}
                                            >
                                                <i className="fa fa-calendar-check-o" style={{ color: '#62B6E8' }}></i>
                                                Request Consultation
                                            </button>
                                            {isAdmin && (
                                                <button
                                                    onClick={() => {
                                                        setShowUserMenu(false);
                                                        navigate('/admin/dashboard');
                                                    }}
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px 16px',
                                                        background: 'none',
                                                        border: 'none',
                                                        textAlign: 'left',
                                                        cursor: 'pointer',
                                                        fontSize: '13px',
                                                        color: '#333',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px'
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.background = '#f5f5f5'}
                                                    onMouseLeave={(e) => e.target.style.background = 'none'}
                                                >
                                                    <i className="fa fa-dashboard" style={{ color: '#62B6E8' }}></i>
                                                    Admin Dashboard
                                                </button>
                                            )}
                                            <div style={{ borderTop: '1px solid #e0e0e0' }}></div>
                                            <button
                                                onClick={handleLogout}
                                                style={{
                                                    width: '100%',
                                                    padding: '10px 16px',
                                                    background: 'none',
                                                    border: 'none',
                                                    textAlign: 'left',
                                                    cursor: 'pointer',
                                                    fontSize: '13px',
                                                    color: '#d32f2f',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }}
                                                onMouseEnter={(e) => e.target.style.background = '#fee'}
                                                onMouseLeave={(e) => e.target.style.background = 'none'}
                                            >
                                                <i className="fa fa-sign-out"></i>
                                                Sign Out
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <>
                                    <Link to="/user-login" title="" className="appointment">SIGN IN</Link>
                                    {isAuthenticated && (
                                        <Link
                                            to="/user-login"
                                            onClick={handleLogout}
                                            style={{
                                                marginLeft: '10px',
                                                padding: '6px 14px',
                                                background: '#e53e3e',
                                                color: '#fff',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                textDecoration: 'none',
                                                display: 'inline-block'
                                            }}
                                            onMouseEnter={(e) => e.target.style.background = '#c53030'}
                                            onMouseLeave={(e) => e.target.style.background = '#e53e3e'}
                                        >
                                            <i className="fa fa-sign-out" style={{ marginRight: '6px' }}></i> SIGN OUT
                                        </Link>
                                    )}
                                </>
                            )}
                            </div>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopBar;
